import requester from '@/lib/axios';
export type ClassesPendingSummaryTotal = {
  pendingReportsCount: number;
  pendingExamsCount: number;
  pendingActivitiesCount: number;
};
const baseUrl = 'analytics/classes/pending-summary/total/';

export const getClassesPendingSummaryTotal = async () => {
  const { data } = await requester().get<ClassesPendingSummaryTotal>(baseUrl);

  return data;
};
